import { stringUtils } from '@ardoq/common-helpers';

export const escapeHTML = (str: any) => {
  return stringUtils
    .ensureString(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
    .replace(/\//g, '&#x2F;');
};

export const unescapeHTML = (str: any) => {
  return stringUtils
    .ensureString(str)
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&#x2F;/g, '/')
    .replace(/&amp;/g, '&');
};

export const fixSVGEscapedName = (str: any, maxLength?: number) => {
  const escaped = stringUtils
    .ensureString(str)
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#039;/gi, "'")
    .replace(/&lt;/gi, '')
    .replace(/&gt;/gi, '')
    .replace(/&#x2F;/gi, '/');

  return maxLength && escaped.length > maxLength
    ? `${escaped.substring(0, maxLength)} ...`
    : escaped;
};
